import {
  IconArrowRight,
  IconChecks,
  IconCircleCheckFilled,
  IconCircleDot,
  IconSparkles,
} from "@tabler/icons-react";
import { motion } from "framer-motion";
import { container, item } from "../homepage/Section1";
import { Bank, Journal, PosOrder, Revenue } from "../../view/FinanceReco";
import VectorArrow from "../../assets/images/fin-rec-asset/Vector 9.svg";
import { Link } from "react-router-dom";

const Section2 = () => {
  const s2Contents = [
    {
      id: "01",
      title: "Revenue vs Payout",
      image: Revenue,
      Problem:
        "Unclear third-party payout data, resulting in confusion and lost profits.",
      Solution:
        "Voosh automatically consolidates and clearly visualizes your payout data from platforms like DoorDash, UberEats, Grubhub, and EZ Cater. You'll see every fee, charge, and adjustment broken down clearly.",
      Benefits:
        "Instantly identify payout discrepancies and automatically push accurate journal entries directly into your accounting software, reducing errors and manual labor.",
      p1: "Spot payout discrepancies instantly",
      p2: "Track hidden charges and adjustments clearly",
      p3: "Automate accounting entries",
    },
    {
      id: "02",
      title: "POS Order Matching",
      image: PosOrder,
      Problem:
        "Revenue leaks from mismatches between your POS and third-party platforms due to canceled or unpaid orders.",
      Solution:
        "Voosh matches every order from your POS to third-party records, flagging discrepancies immediately.",
      Benefits:
        "Quickly recover missed revenue and reduce manual checks. Voosh automates this process, making sure you earn every dollar owed.",
      p1: "Identify order discrepancies in real-time",
      p2: "Reduce manual verification processes",
      p3: "Quickly recover lost revenue",
    },
    {
      id: "03",
      title: "Bank Reconciliation",
      image: Bank,
      Problem:
        "Complex bank reconciliation leading to errors, increased workloads, and delayed cash flow.",
      Solution:
        "Voosh automatically connects third-party sales data, payout reports, and bank deposits, flagging any mismatches instantly.",
      Benefits:
        "Ensure cash flow accuracy, streamline your accounting processes, and maintain daily financial clarity with minimal effort.",
      p1: "Automatically detect delayed or missing deposits",
      p2: "Streamline reconciliation processes",
      p3: "Ensure daily cash flow accuracy",
    },
    {
      id: "04",
      title: "Journal Entries Automation",
      image: Journal,
      Problem:
        "Time-consuming and error-prone manual entry of financial data into accounting systems.",
      Solution:
        "Voosh automatically syncs deductions, deposits, and POS sales data directly into your accounting software like Restaurant365, QuickBooks, or NetSuite.",
      Benefits:
        "Completely eliminate manual entry, ensuring accurate financial data and effortless scalability as your business grows.",
      p1: "Eliminate manual journal entry",
      p2: "Ensure precise financial records",
      p3: "Scale effortlessly with your business",
    },
  ];
  return (
    <div className="s2-fin-reco f-width m-auto">
      <p className="text-center color-brand text-uppercase fw-bold fs-16px t-a-s">
        <IconCircleDot stroke={3} /> Why Finance Reconciliation?
      </p>
      <motion.p
        variants={container}
        whileInView="visible"
        initial="hidden"
        className="text-center fs-md t-a-s"
      >
        See exactly where your money is going.
      </motion.p>
      <div className="d-flex justify-content-between s2-fin-reco-mb t-a-s">
        <motion.p
          variants={item}
          whileInView="visible"
          initial="hidden"
          transition={{ duration: 0.5 }}
        >
          <IconChecks className="color-brand" /> Instantly Detect Revenue Leaks
        </motion.p>
        <motion.p
          variants={item}
          whileInView="visible"
          initial="hidden"
          transition={{ duration: 1 }}
        >
          <IconChecks className="color-brand" /> Eliminate Manual Accounting
          Errors
        </motion.p>
        <motion.p
          variants={item}
          whileInView="visible"
          initial="hidden"
          transition={{ duration: 1.5 }}
        >
          <IconChecks className="color-brand" /> Ensure Financial Accuracy Daily
        </motion.p>
        <motion.p
          variants={item}
          whileInView="visible"
          initial="hidden"
          transition={{ duration: 2 }}
        >
          <IconChecks className="color-brand" /> Automate Journal Entries
        </motion.p>
      </div>
      <img
        src={VectorArrow}
        className="fin-fetures-arrow"
        alt="features guide arrow"
      />
      {s2Contents.map((s2Content, index) => (
        <div className="row s2-row-bg rounded-4" key={index}>
          <div className="col-sm-12 col-lg-6 align-content-around p-15px">
            <p className="color-brand">{s2Content.id}</p>
            <p className="fs-32 s2-t-m">{s2Content.title}</p>
            <p className="s2-t-m">
              <font className="fw-bold">Problem</font>: {s2Content.Problem}
            </p>
            <p className="s2-t-m">
              <font className="fw-bold">Solution</font>: {s2Content.Solution}
            </p>
            <div className="d-flex light-brand-bg rounded">
              <IconSparkles
                className="color-brand"
                style={{ width: "100px" }}
              />
              <p className="mb-0">
                <font className="fw-bold">Benefits</font>: {s2Content.Benefits}
              </p>
            </div>
            <Link
              to={
                "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal&__hstc=181257784.c6a9d1b3be4a6fd2ed9c2295680beb42.1703009108941.1746471743378.1746554024258.302&__hssc=181257784.2.1746554024258&__hsfp=961219941"
              }
              rel="noreferrer"
              target="_blank"
            >
              <div className="btn brand-bg text-white rounded-pill shadow">
                {" "}
                Learn more <IconArrowRight className="btn-arr" />
              </div>
            </Link>
          </div>
          <div className="col-sm-12 col-lg-6 p-15px">
            <motion.img
              variants={item}
              whileInView="visible"
              initial="hidden"
              transition={{ duration: 1 }}
              className="img-fluid"
              src={s2Content.image}
              alt={s2Content.title}
            />
          </div>
          <div className="d-flex text-success justify-content-around l-green-bg py-3 rounded-bottom-4">
            <motion.p
              variants={item}
              whileInView="visible"
              initial="hidden"
              transition={{ duration: 0.5 }}
              className="mb-0"
            >
              <IconCircleCheckFilled /> {s2Content.p1}
            </motion.p>
            <motion.p
              variants={item}
              whileInView="visible"
              initial="hidden"
              transition={{ duration: 0.7 }}
              className="mb-0"
            >
              <IconCircleCheckFilled /> {s2Content.p2}
            </motion.p>
            <motion.p
              variants={item}
              whileInView="visible"
              initial="hidden"
              transition={{ duration: 0.9 }}
              className="mb-0"
            >
              <IconCircleCheckFilled /> {s2Content.p3}
            </motion.p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Section2;
